import { globalEndpoints } from "../globalEndpoints";
import { mainApi } from "../mainApi";

const path = "v2/device-parameter";
const name = "DeviceParameter";

export const deviceParameterApi = mainApi.injectEndpoints({
  endpoints: (builder) => ({
    ...globalEndpoints(builder, path, name, []),
  }),
});

export const {
  useGetAllDeviceParameterQuery,
  useGetByIdDeviceParameterQuery,

  useLazyGetAllDeviceParameterQuery,
  useLazyCompanyCheckQuery,

  useCreateDeviceParameterMutation,
  useUpdateDeviceParameterMutation,
  useDeleteDeviceParameterMutation,
} = deviceParameterApi;
